module.exports = __webpack_public_path__ + "static/profile-1f5c9488440bf4f96ba976b825897f3c.png";